import { SaveEssay } from './../testtaker/test/logicaltest.model';
//import { Category_Time } from './question.service';
//import { Local } from './question.service';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { SaveModel } from '../testtaker/test/logicaltest.model';
import { AnyARecord } from 'dns';
import { mediaModel } from '../upload-audio-video-images/upload-audio-video-images.model';
import { __spreadArrays } from 'tslib';
import { template } from 'lodash';

export interface Question {
    questionId: string;
    question_text: string;
    answerId: string;
    Answer_Text: string;
    Duration:string;


    // options:Array<Overall_Result>;
  }
  export interface Local{
    Id:any;
    set: any;
    paper : any;
    schedule : any;
    email : any;
    schedule_master_Id : any;
  }
  // export interface student_essay {
  //   id:string;
  //   type:string;
  // }
  export interface Category_Time{
   start_time:string;
   end_time:string;
   category_id:string;
   user_id:string;
  }

  export interface Section_Time{
    start_time:string;
    end_time:string;
    section_name:string;
    user_id:string;
    email:string;
    category_id:string;
   }

   export interface audioitem{
    file: string;
   }
  
  
  export interface User_Time{
    login_time: string;
    logoff_time: string;
  }
  export interface sectioncollection{
    section_name: string,
    duration: string
  }

  interface TokenResponse {
    token: string;
   }

@Injectable()
export class questionService {
    private token: string;
    storeImagePath: any;
    // getImagePaths: any;

  constructor(private http: HttpClient) {}

  public displayQuestion(local: Local): Observable<any> {
    console.log("local***********",local)
    const headers = new HttpHeaders().append('header', 'value');
    let params = new HttpParams().set('Id', local.Id)
      .set('email', local.email)
      .set('set', local.set)
      .set('paper', local.paper)
      .set('schedule', local.schedule)
      .set('schedule_master_Id', local.schedule_master_Id);
    console.log(params)
    const base = this.http.get('/users/category/display_question', { headers, params });
    const request = base.pipe(
      map((data: TokenResponse) => {
        console.log(data);
        return data;
      })
    );
    return request;
  }

  // public display_essay(item: student_essay): Observable<any> {
  //
  //   const b = this.http.post('/users/display_essays', item);
  //   const request = b.pipe(
  //     map((data: TokenResponse) => {
  //
  //       return data;
  //     })
  //   );
  //   return request;
  // }

  // display particular question
  // public displayQuestion(id): Observable<any> {
  //
  //   var body = {
  //      id:id
  //   }
  //   const base = this.http.post('/users/display_question', body);
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //         return data;
  //     })
  //   );
  //   return request;
  // }

  public cate_time(time_item: Category_Time,user_id:any,schedule_id:any,email:any): Observable<any> {

  let temp ={
    time_item:time_item,
    user_id:user_id,
    schedule_id:schedule_id,
    email:email
  }
  console.log("temp inside cate_yime",temp)
    const base = this.http.post('/users/time', temp);

    const request = base.pipe(
    map((data: TokenResponse) => {


    return data;

        })
      );
    return request;
    }

    public section_time(time_item: Section_Time): Observable<any> {

      console.log(time_item);
      const base = this.http.post('/users/time/sectiontime', time_item);
  
      const request = base.pipe(
      map((data: TokenResponse) => {
  
  
      return data;
  
          })
        );
      return request;
      }

      public audio(bloburl: audioitem): Observable<any> {

        console.log(bloburl)
        const base = this.http.post('/users/time/audio',bloburl);
    
        const request = base.pipe(
        map((data: TokenResponse) => {
    
    
        return data;
    
            })
          );
          return request;
        }

        public uploadImage(data: Array<mediaModel>): Observable<any>  {
          console.log("Inside Upload Image service");
          const url = '/users/upload/media-question';
       //   const body = { imageDataUrl };
          console.log("Printing .... BODY",data);
          const base =  this.http.post('/users/upload/question', data);
          const request = base.pipe(
            map((data) => {
              return data;
            })
          );
          return request;
        }
  
    // public save_user_time(time_item: User_Time): Observable<any> {
    //
    //
    //   const base = this.http.post('/users/login_time', time_item);
    //
    //   const request = base.pipe(
    //   map((data: TokenResponse) => {
    //

    //   return data;

    //       })
    //     );
    //   return request;
    //   }



    public displayAnswer(id): Observable<any> {

    var body = {
      id:id
    }
    const base = this.http.post('/users/category/display_answer', body);
    const request = base.pipe(
      map((data: TokenResponse) => {

          return data;
      })
    );
    return request;
  }

  public displayurl(id): Observable<any> {

    var body = {
      id:id
    }
    const base = this.http.post('/users/category/q_url', body);
    const request = base.pipe(
      map((data: TokenResponse) => {

          return data;
      })
    );
    return request;
  }


public submit(item: Map<string, Array<any>>): Observable<any> {
console.log("item inside submit*****",item)
let temp = [];
item.forEach(function(value,key){
  console.log(`Map key is:${key} and value is:${value}`);
  temp.push(value)
});

    const base =  this.http.post('/users/save_answer/mcq', temp);


const request = base.pipe(
map((data: TokenResponse) => {


return data;

    })
  );

return request;

}

public save_individual_mcq(item: any,length): Observable<any> {
  console.log("item*****",item)
  let temp = [];

  if(length >0){
    item.forEach(function(value,key){
      console.log(`Map key is:${key} and value is:${value}`);
      temp.push(value)
    });
  }else{
    temp.push(item)
  }

  
  const base = this.http.post('/users/save_answer/mcq', temp);
  
  const request = base.pipe(
  map((data: TokenResponse) => {
  
  
  return data;
  
      })
    );
  
  
  
  
  return request;
  
  }

  public save_individual_essayanswer(item: any,length): Observable<any> {
    console.log("item*****",item)
    let temp = [];

    if(length >0){
      item.forEach(function(value,key){
        console.log(`Map key is:${key} and value is:${value}`);
        temp.push(value)
      });
    }else{
      temp.push(item)
    }
    console.log("temp",temp)
    
    const base = this.http.post('/users/save_answer/essay', temp);
    
    const request = base.pipe(
    map((data: TokenResponse) => {
    
    
    return data;
    
        })
      );
    
    
    
    
    return request;
    
    }

public submit_essay(item:Map<string, Array<any>>): Observable<any> {
console.log("item",item)
let temp = [];
item.forEach(function(value,key){
  console.log(`Map key is:${key} and value is:${value}`);
  temp.push(value)
});
console.log("temp",temp)

  const base = this.http.post('/users/save_answer/essay', temp);

  const request = base.pipe(
  map((data: TokenResponse) => {


  return data;

      })
    );




  return request;

  }



  public get_user_selected_answers(userId:String,scheduleId:String,Section_Id:string): Observable<any> {
    
      const base = this.http.get(`/users/save_answer/mcq?Test_Taker_User_Id=${userId}&Schedule_id=${scheduleId}&Section_Id=${Section_Id}`);    
      const request = base.pipe(
      map((data: TokenResponse) => {    
      return data;
          })
        );  
      return request;
    
      }
  
      public get_user_answered_free_text_answers(userId:String,scheduleId:String,Section_Id:string): Observable<any> {
    
        const base = this.http.get(`/users/save_answer/freeText?Test_Taker_User_Id=${userId}&Schedule_id=${scheduleId}&Section_Id=${Section_Id}`);    
        const request = base.pipe(
        map((data: TokenResponse) => {    
        return data;
            })
          );  
        return request;
      
        }    

  public submit_individual_audio(item: any,length): Observable<any> {

    let temp = [];

    if(length >0){
      item.forEach(function(value,key){
        console.log(`Map key is:${key} and value is:${value}`);
        temp.push(value)
      });
    }else{
      temp.push(item)
    }
  
    const base = this.http.post('/users/save_answer/audio', temp);
  
    const request = base.pipe(
    map((data: TokenResponse) => {
  
  
    return data;
  
        })
      );
  
  
  
  
    return request;
  
    }

  public submit_data(item:Map<String, Array<any>>): Observable<any> {

    let temp = [];
item.forEach(function(value,key){
  console.log(`Map key is:${key} and value is:${value}`);
  temp.push(value)
});
  
    const base = this.http.post('/users/save_answer/audio', temp);
  
    const request = base.pipe(
    map((data: TokenResponse) => {
  
  
    return data;
  
        })
      );
  
  
  
  
    return request;
  
    }

    public submit_data_video(item: Array<SaveEssay>): Observable<any> {

      let temp = [];
      for(let i in item){
      temp.push(item[i]);
      }
    
      const base = this.http.post('/users/save_answer/video', temp);
    
      const request = base.pipe(
      map((data: TokenResponse) => {
    
    
      return data;
    
          })
        );
    
    
    
    
      return request;
    
      }
    
    

    


    getImagePaths(pushedquestionStyle) {
      console.log("Pushed Question Style ",pushedquestionStyle)
      console.log("Inside question service get image path");
      // const keyPath = this.http.get("/users/images");
      // console.log("Key Path ***** ",keyPath);
      // return keyPath;

      const destinationFolderFound = pushedquestionStyle.toLowerCase();

      const targetFolderUrl = "/users/upload/mediafiles?folder=" + destinationFolderFound;
//const targetFolderUrl = pushedsubCategory;

      const base = this.http.get(targetFolderUrl);

      const request = base.pipe(
        map((data: TokenResponse) => {
          console.log("Inside request base.pipe map of getImage Path");
      
        console.log("Inside base pipe printing DATA",data);
        return data;
      
            })
          );

      
        console.log("REQUEST OF BASE ",request );
      
      
        return request;

    }
  
  


}





